import http from './http'

function getOrganizationByName (name) {
  return http({
    method: 'GET',
    url: '/organizations',
    params: {
      name
    }
  })
}

function getOrganizations () {
  return http({
    method: 'GET',
    url: '/organizations/all'
  })
}

export {
  getOrganizationByName,
  getOrganizations
}



// WEBPACK FOOTER //
// ./src/services/api/organization.js